const initialState = {
  fetching: false,
};

export default function planReducer(currentState = initialState, action) {
  switch (action.type) {
    case 'PLANS_FETCHING':
      return { ...currentState, fetching: true };
    case 'PLANS_FETCHED':
      return { ...currentState, data: action.payload.data, fetching: false };
    default:
      return currentState;
  }
}
